const { Serializer } = require("jsonapi-serializer");

module.exports = {
  addFngInfoSerializer: (meta = {}) =>
    new Serializer("store", {
      meta,
      pluralizeType: false,
      keyForAttribute: "snake_case",
      attributes: [
        "request_campaign_id",
        "fng_fee_percentage",
        "fng_coverage_percentage",
        "fng_warranty_line",
        "user_email",
        "user_ip"
      ]
    })
};
